import React, { Component } from 'react'
import './App.css'


var hold = document.getElementById("webchat")
console.log(hold) 

export class webchat extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            boo: true
        }
      this.webFunc = this.webFunc.bind(this)  
    }
    webFunc() {
        var hold = document.getElementById("webchat")
      
if (this.state.boo) {
    hold.style.display = "block"
} else {
    hold.style.display = "none"
}

this.setState({
    boo: !this.state.boo
})


console.log(this.state.boo)
    }

    render() {
        return (
            <div id="hacker"> 
                 <div id="fixedbutton">

<div id="webchat">
<p id="webtext">Hi there!<br/>How can I assist you today?</p>
<input type="text" id="webinput" defaultValue="Message" /> 

</div>

<div id="websvg" onClick={this.webFunc}>
<svg   width="92" height="97" viewBox="0 0 92 97" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="42" cy="42" r="42" fill="#111B47"/>
<circle cx="76" cy="81" r="16" fill="#111B47"/>
<path fillRule="evenodd" clipRule="evenodd" d="M56.9581 48.2083L59.2498 64.2499L40.9164 55.0833L56.9581 48.2083Z" fill="white"/>
<path fillRule="evenodd" clipRule="evenodd" d="M40.9166 59.6667C28.2601 59.6667 17.9999 51.4586 17.9999 41.3333C17.9999 31.2081 28.2601 23 40.9166 23C53.5731 23 63.8333 31.2081 63.8333 41.3333C63.8333 51.4586 53.5731 59.6667 40.9166 59.6667Z" fill="white"/>
</svg> 
</div> </div> 
            </div>
        )
    }
}

export default webchat
